import "./SelectProjectsModal.css";

import { Dispatch, SetStateAction } from "react";

import { SelectData } from "../../../../../../models";
import { ServiceError } from "../../../../../../service/Shared";
import { ActionButtons, Column, ErrorBox, KanaTooltip, Modal, Row } from "../../../../../../widget";
import { AutocompleteMultiSelect } from "../../../../../../widget/forms/AutocompleteMultiSelect";
import { useSelectProjectsModal } from "./useSelectProjectsModal";

interface SelectProjectModalProps {
  errors: ServiceError[] | undefined;
  roadmapProjectUuids: string[];
  setRoadmapProjectUuids: Dispatch<SetStateAction<string[]>>;
  projectsMultiSelectData: SelectData | undefined;
  onSaveProjectsSelectData: () => void;
  show: boolean;
  closePanel: () => void;
  fetchSelectData: (displayName?: string) => Promise<void>;
}
export const SelectProjectsModal = ({
  errors,
  roadmapProjectUuids,
  setRoadmapProjectUuids,
  projectsMultiSelectData,
  onSaveProjectsSelectData,
  show,
  closePanel,
  fetchSelectData,
}: SelectProjectModalProps): JSX.Element => {
  const {
    saveProjectsSelectDataAndCloseDropdown,
    onDropdownVisibleChange,
    closePanelAndDropdown,
    open,
    projectsMultiSelectDataOrder,
  } = useSelectProjectsModal({
    roadmapProjectUuids,
    projectsMultiSelectData,
    closePanel,
    onSaveProjectsSelectData,
  });
  return (
    <Modal onClose={closePanelAndDropdown} show={show} title="Select projects to add to roadmap">
      <Row spacingV="xl" justify="center">
        <Column span={8}>
          <p className="body1">
            To populate the project roadmap, select up to 15 projects from the dropdown below. Only projects with an
            assigned workflow will appear on the roadmap. To assign workflows, visit the workflows section.
          </p>
        </Column>
      </Row>
      {errors && errors.length > 0 && (
        <Row spacingV="xl">
          <Column span={6} offset={3}>
            <ErrorBox text={errors.map((error) => error.message)} />
          </Column>
        </Row>
      )}
      <form className="SelectProjectsModalForm" onSubmit={(e) => saveProjectsSelectDataAndCloseDropdown(e)}>
        <Row spacingV="xl" justify="center">
          <Column span={6}>
            <AutocompleteMultiSelect
              label="Add projects"
              placeholder="Search projects"
              className="EditProjectsDropdown"
              tooltip={
                <KanaTooltip
                  tooltipHeader=""
                  tooltipText="If you can't see your project here, it doesn't have a workflow assigned. You can assign a workflow here TODO [link to workflows section]."
                />
              }
              values={roadmapProjectUuids}
              data={projectsMultiSelectData ?? []}
              order={projectsMultiSelectDataOrder}
              onChange={(values) => setRoadmapProjectUuids(values)}
              onTypeSearch={fetchSelectData}
              overrideOpen={open}
              overrideOnDropdownVisibleChange={onDropdownVisibleChange}
              getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
            />
          </Column>
        </Row>
        <Row spacingV="xl" justify="center">
          <Column span={6}>
            <ActionButtons onCancel={closePanelAndDropdown} fullWidth />
          </Column>
        </Row>
      </form>
    </Modal>
  );
};
